module.exports = __webpack_public_path__ + "static/media/numerosLabel.5cc56e49.png";